<!-- Toolbar: matches screenshot design -->
<header
  class="bg-white border-b border-neutral-200 pb-lg flex items-center gap-lg">
  <!-- Today button -->
  <button
    type="button"
    class="flex items-center gap-sm bg-primary-50 hover:bg-primary-100 rounded-sm px-lg py-sm text-sm font-medium text-primary-500 transition-colors"
    mwlCalendarToday
    [viewDate]="viewDate()"
    (viewDateChange)="onViewDateChange($event)">
    <lib-calendar-icon iconClass="size-5 p-0 text-primary-500" />
    {{ 'calendar_toolbar_today_button' | transloco }}
  </button>

  <!-- separator -->
  <div class="h-8 w-0.25 bg-neutral-200"></div>

  <!-- Prev / Next arrows -->
  <button
    type="button"
    class="p-sm rounded-md hover:bg-neutral-100 text-neutral-500 hover:text-neutral-700 transition-colors"
    mwlCalendarPreviousView
    [view]="view()"
    [viewDate]="viewDate()"
    (viewDateChange)="onViewDateChange($event)">
    <lib-chevron-right-icon iconClass="size-6 rotate-180 text-neutral-500" />
  </button>

  <button
    type="button"
    class="p-sm rounded-md hover:bg-neutral-100 text-neutral-500 hover:text-neutral-700 transition-colors"
    mwlCalendarNextView
    [view]="view()"
    [viewDate]="viewDate()"
    (viewDateChange)="onViewDateChange($event)">
    <lib-chevron-right-icon iconClass="size-6 text-neutral-500" />
  </button>

  <!-- Period title -->
  <button
    type="button"
    class="text-base font-medium text-neutral-900 flex items-center gap-sm select-none"
    (click)="
      toggleDatePickerCalendar.set(!toggleDatePickerCalendar());
      $event.stopPropagation()
    ">
    {{
      viewDate()
        | calendarDate: view() + 'ViewTitle' : 'en' : weekStartsOnNumber()
    }}

    <lib-chevron-right-icon
      [iconClass]="
        'size-5 text-neutral-900 do-not-transform' +
        (toggleDatePickerCalendar() ? ' rotate-270' : ' rotate-90')
      " />

    <lib-date-picker-calendar
      [showCalendar]="toggleDatePickerCalendar()"
      [showInput]="false"
      [currentDate]="selectedDateView()"
      [selectWeekRange]="weekStartsOnDate()"
      (selectDate)="onViewDateChange($event)"
      [currentMonth]="selectedDateView().getMonth()"
      [isShowMonths]="view() === CalendarView.Month || isShowMonths()"
      (showMonths)="toggleMonthPicker()"
      (selectMonth)="handleMonthSelection($event)"
      [currentYear]="selectedDateView().getFullYear()"
      [isShowYears]="isShowYears()"
      (showYears)="toggleYearPicker($event)"
      (selectYear)="handleYearSelection($event)" />
  </button>

  <!-- Spacer -->
  <div class="flex-1"></div>

  <!-- View switcher dropdown -->
  <div class="relative">
    <button
      type="button"
      class="flex items-center gap-sm text-base font-medium text-neutral-900 hover:bg-neutral-50 transition-colors"
      (click)="toggleViewDropdown(); $event.stopPropagation()">
      <span class="flex-1 text-start">
        @switch (view()) {
          @case (CalendarView.Month) {
            {{ 'calendar_toolbar_month_view_item_label' | transloco }}
          }
          @case (CalendarView.Week) {
            {{ 'calendar_toolbar_week_view_item_label' | transloco }}
          }
          @case (CalendarView.Day) {
            {{ 'calendar_toolbar_day_view_item_label' | transloco }}
          }
        }
      </span>

      <lib-chevron-right-icon
        [iconClass]="
          'size-5 text-neutral-900 do-not-transform' +
          (viewDropdownOpen() ? ' rotate-270' : ' rotate-90')
        " />
    </button>

    @if (viewDropdownOpen()) {
      <button
        type="button"
        class="absolute end-0 top-full mt-x-sm w-32 bg-white border border-neutral-200 rounded-lg shadow-lg z-50 overflow-hidden"
        (click)="$event.stopPropagation()">
        @for (viewOption of calendarViews(); track viewOption.label) {
          <button
            type="button"
            class="flex items-center justify-between w-full px-md py-sm text-sm font-medium transition-colors"
            [class]="
              view() === viewOption.view
                ? 'text-primary-600 bg-primary-50'
                : 'text-neutral-700 hover:bg-neutral-50'
            "
            (click)="setView(viewOption.view)">
            {{ viewOption.label | transloco }}
            @if (view() === viewOption.view) {
              <lib-check-icon
                iconClass="size-3 text-primary-500 do-not-transform" />
            }
          </button>
        }
      </button>
    }
  </div>
</header>
